module.exports = "/assets/data/cc963e288bbfebd46b6c961dee0606f4-RG27.data.json";